import { AMPLITUDE_SCALE_SLIDER_VISIBLE } from "@/enum/cookie.name.enum.ts";
import { useCookies } from "react-cookie";

function useAmplitudeScaleSliderVisible(): [boolean, (newValue: boolean) => void] {
  const [cookies, setCookie] = useCookies([AMPLITUDE_SCALE_SLIDER_VISIBLE]);

  const handleSet = (newMode: boolean) => {
    setCookie(AMPLITUDE_SCALE_SLIDER_VISIBLE, newMode);
  }

  return [
    cookies.amplitudeScaleSliderVisible,
    handleSet
  ];
}

export default useAmplitudeScaleSliderVisible;
